import * as RadixTooltip from "@radix-ui/react-tooltip";

/**
 * Balão de ajuda de um controle — o que aquele ícone faz.
 *
 * O `title` nativo do HTML já existia em quase todo botão de ícone, mas ele
 * demora cerca de um segundo para aparecer, some sozinho, não segue o desenho
 * do sistema e não aparece com foco de teclado. Numa linha com sete ícones
 * seguidos — ver, editar, duplicar, etiqueta, desativar, vincular, excluir — o
 * atraso é a diferença entre reconhecer o botão e clicar no errado.
 *
 * O balão fica em portal: dentro de uma célula de tabela com rolagem própria ou
 * de um diálogo, um elemento posicionado no fluxo seria cortado pela borda.
 *
 * Cuidado ao usar dentro de um `asChild` do Radix (Dialog.Trigger, Dialog.Close):
 * ali o filho precisa ser o elemento em si, então o balão vai POR FORA do
 * componente do Radix, nunca entre ele e o botão.
 *
 * Ele DESCREVE, não nomeia: quem dá nome ao botão continua sendo o `aria-label`
 * (o Radix pendura o balão como `aria-describedby`). Por isso o Button, ao
 * adotar o balão, promove o `title` a `aria-label` quando não há um — senão o
 * leitor de tela anunciaria só "botão".
 */
export default function Tooltip({ label, children, side = "top", delay = 150 }) {
  if (!label) return children;

  return (
    <RadixTooltip.Provider delayDuration={delay} skipDelayDuration={300}>
      <RadixTooltip.Root>
        {/* asChild: o gatilho É o próprio botão. Um wrapper a mais quebraria
            quem depende do lugar do botão na grade (col-span) ou no flex. */}
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            sideOffset={6}
            collisionPadding={8}
            // z acima do diálogo (z-50): o balão também serve os botões de dentro dele.
            className="z-[60] max-w-xs select-none rounded-md bg-slate-900 px-2 py-1 text-xs font-medium text-white shadow-lg"
          >
            {label}
            <RadixTooltip.Arrow className="fill-slate-900" />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
